<template>
  <div>
    <div class="body-bold-medium pl-2">
      {{ $t('message.pages.AssistentIntern.configChat') }}
    </div>
    <div class="body-regular-smaller pt-2 pl-2">
      <span class="body-regular-smaller"
        >{{ $t('message.pages.AssistentIntern.subtitleConfigChat') }}
        <span class="cursor-pointer">
          <a type="secondary" size="xsmall" @click="openHelp"
            >{{ $t('message.pages.AssistentIntern.actions.knowMore') }}
            <v-icon size="11px">mdi-open-in-new</v-icon></a
          ></span
        ></span
      >
    </div>
    <v-tabs
      v-model="activeTab"
      class="playr-tabs pl-2"
      align-tabs="start"
      fixed-tabs
      @change="saveActiveTab"
    >
      <v-tab>{{ $t('message.pages.AssistentIntern.general') }}</v-tab>
      <v-tab>{{ $t('message.pages.AssistentIntern.instructions') }}</v-tab>
      <v-tab>{{ $t('message.pages.AssistentIntern.knowledgeBase') }}</v-tab>
    </v-tabs>

    <v-tabs-items v-model="activeTab">
      <v-tab-item>
        <portal-target name="agent-general" multiple></portal-target>
      </v-tab-item>
      <v-tab-item>
        <portal-target name="agent-instructions" multiple></portal-target>
      </v-tab-item>
      <v-tab-item>
        <portal-target name="agent-knowledge" multiple></portal-target>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isInitialized: false,
      internalTab: null,
    }
  },
  computed: {
    locale() {
      return this.$i18next.resolvedLanguage
    },
    playerSettingsArticle() {
      if (this.locale === 'en') {
        return 'https://help.pandavideo.com/en-us/article/pandaassist-ai-how-to-create-ai-chats-in-your-videos-r4624o/'
      }
      if (this.locale === 'es') {
        return 'https://help.pandavideo.com/es/article/pandaassist-ai-como-crear-chats-con-ia-en-tus-videos-1ewhd32/'
      }
      return 'https://help.pandavideo.com/pt-br/article/pandaassist-ai-como-criar-chats-com-ia-nos-seus-videos-zdy32s/'
    },
    activeTab: {
      get() {
        return this.internalTab ?? this.$route.query.tab ?? 0
      },
      set(val) {
        this.internalTab = val
      },
    },
  },
  methods: {
    saveActiveTab() {
      if (this.isInitialized) {
        localStorage.setItem('activeTabAgent', this.activeTab)
      }
    },
    loadActiveTab() {
      const savedTab = localStorage.getItem('activeTabAgent')
      this.activeTab = savedTab !== null ? parseInt(savedTab, 10) : 0
    },
    openHelp() {
      window.open(this.playerSettingsArticle, '_blank')
    },
  },
  mounted() {
    if (!this.$route.query.tab) {
      this.loadActiveTab()
    }
    this.isInitialized = true
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_typography';
.cursor-pointer {
  cursor: pointer;
}
.tab-icon {
  width: 18px;
  height: 24px;
  vertical-align: middle;
  background-size: 14px;
  background-position: right;
  background-repeat: no-repeat;
}
.playr-tabs {
  margin-top: $spacing-05;
  &::v-deep {
    .v-slide-group__prev {
      display: none !important;
    }
    .v-slide-group__next {
      display: none !important;
    }
    .v-slide-group__content {
      flex: 1 1 auto !important;
    }
  }
  &.v-tabs {
    padding: 0;
    &::v-deep {
      .v-tabs-bar {
        .v-tab {
          font-size: $font-size-small;
          height: 24px;
          text-transform: initial;
          letter-spacing: 0px;
          border-bottom: 2px solid transparent;
          padding: 0;
          min-width: auto;
          margin-right: $spacing-05;
          white-space: nowrap;
          justify-content: start;
          max-width: fit-content;
          margin-left: 0 !important;

          &--active {
            color: varFigma(brand-50);
            border-bottom: 2px solid varFigma(brand-50);

            &:hover {
              color: varFigma(brand-40-dark);
            }
          }

          &:not([class*='active']) {
            color: var(--v-neutral-lighten1);

            &:hover {
              color: varFigma(neutral-30-base);
              border-bottom: 2px solid varFigma(neutral-80-lighter);
            }
          }
        }
        &.v-tabs-bar--is-mobile {
          .v-tab {
            font-size: 12px;
          }
        }
      }
      & .v-tab:hover::before,
      .v-tab::before {
        opacity: 0 !important;
      }
      & .v-tab:focus::before {
        opacity: 0 !important;
      }
    }

    &::v-deep {
      &.theme--dark {
        > .v-tabs-bar {
          .v-tab {
            &--active {
              color: var(--v-brand-lighten1);
            }
          }
        }
      }

      .v-tabs-slider-wrapper {
        display: none !important;
      }
    }
  }
}
</style>
